const kaGE= {
    login: {
      title: 'შესვლა',
      sign_in_btn: 'შესვლა'
    },
    bar: {
        logout: 'გამოსვლა',
        languages: 'ენები',
        settings: 'პარამეტრების გახსნა'
    },
    language: {
      name: 'ინგლისური (აშშ)',
    },
    attributePage: {
        title: 'ატრიბუტების ცვლილებები',
        viewChanges: 'ცვლილებების ნახვა',
        dateTime: 'თარიღი',
        notificationType: 'შეტყობინების ტიპი',
        notificationValue: 'შეტყობინების მნიშვნელობა',
        oldValue: 'ძველი მნიშვნელობა',
        newValue: 'ახალი მნიშვნელობა',
        accept: 'დათანხმება',
        reject: 'უარყოფა',
    },
    Home: 'საწყისი',
    load: 'საწყისი ჩატვირთვის შესრულება...',
    Requested: "მოთხოვნილი",
    Viewed: "ნანახი",
    Executing: "შესრულების პროცესში",
    Completed: "დასრულებული",
    Expired: "ვადაგასული",
    Cancelled: "გაუქმებული",
    Error: "შეცდომა",
    Rejected: "უარყოფილი",
    error: 'რაღაც შეცდომა მოხდა; გთხოვთ, ხელახლა სცადოთ მოგვიანებით.',
    displayname: 'გამოსაჩენი სახელი',
    givenname: 'სახელი',
    surname: 'გვარი',
    email: 'ელფოსტა',
    mail: 'ელფოსტა',
    name: 'სახელი',
    firstname: 'სახელი',
    lastname: 'გვარი',
    footer_copyright: 'ყველა უფლება დაცულია.'
  };
  
  export default kaGE;
  